import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import Slider from "react-slick";
import api from '@/service/api';

const Swiper = (props) => {
  const {
    images,
    changeIndex
  } = props;

  const settings = {
    autoPlay: true,
    dots: false,
    infinite: true,
    speed: 200,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: changeIndex
  };

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <Slider {...settings} >
      {
        images.map((item, index) => {
          return (
            <div className='imgItem' key={'imgItem' + index}>
              <img src={api.getResource(item)} alt="recommend product preview image" />
            </div>
          )
        })
      }
    </Slider>
  )
}

Swiper.propTypes = {
  images: PropTypes.array,
  changeIndex: PropTypes.func
}
export default Swiper